import { InjectionToken } from '@angular/core';
import { MFARedirectUrlMap } from '../mfa/types';

export const MFA_CONFIG = new InjectionToken<MFARedirectUrlMap>('MFA_CONFIG');
